var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContractEditorCore',{attrs:{"mode":"contract","non-editable-component":_vm.nonEditableComponent,"editor-component":_vm.editorComponent,"show-start-date":true,"show-payment-validation":true,"responsable-from-state":'contract',"document-label":'Contrato'},on:{"open-cost-breakdown-modal":_vm.openCostBreakdownModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }